module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"ian hundere / portfolio","short_name":"hunde.re","description":"ian hundere / lead devops engineer specializing in software supply-chain security / cloud infrastructure + devops","lang":"en","start_url":"/","background_color":"#1b1f22","theme_color":"#1b1f22","display":"minimal-ui","icon":"src/images/ianhundere.jpg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"73015e698e0b0651134fbc0da7dfbdcf"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
